/*
 * File: auto-transition.vue.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:50:24
 * Modified By: Val Liu
 * -----
 */

import { Vue, Component, Prop, Model, Emit, Watch, Inject } from "vue-property-decorator";

enum AnimationDirection {
    RTL,
    LTR,
}

@Component
export default class AutoTransition extends Vue {
    /// public ///////////////////////////////////////////////////////////////////////////
    /// direct props ////////////////////////////
    @Prop({ type: Number, default: 0 })
    step!: number;

    @Prop({ type: String, default: "iv-direction-slide" })
    type!: string;

    @Prop({ type: String, default: "div" })
    tag!: string;
    //////////////////////////////////////////////////////////////////////////////////////

    /// private //////////////////////////////////////////////////////////////////////////
    /// private helper
    @Watch("step")
    private onStepChanged(newValue: number, oldValue: number) {
        this.animeDirection =
            newValue >= oldValue ? AnimationDirection.LTR : AnimationDirection.RTL;
    }

    /// handle animation
    private beforeEnter() {
        let el = arguments[0];
        el.style.width = "inherit";
    }
    private beforeLeave() {
        let el = arguments[0];
        el.style.width = `${el.offsetWidth}px`;
    }
    private animeDirection: AnimationDirection = AnimationDirection.LTR;
    private get animeName() {
        return this.animeDirection === AnimationDirection.LTR
            ? "auto-slide-first"
            : "auto-slide-second";
    }
    //////////////////////////////////////////////////////////////////////////////////////
}
